/* Construction Manuals theme behaviours.
 *
 * 1. Seedance loops   (.am-video[data-am-video])   poster→video crossfade, hover / in-view play,
 *                                                   reduced-motion + data-saver + missing-file fallbacks
 * 2. Machine finder   ([data-am-finder])            routes class + brand + model to the right URL
 * 3. Scoped search    ([data-am-scoped-search])     prefixes the product type on collection pages
 * 4. Sticky buy bar   ([data-am-sticky])            mirrors the main product form
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var touchOnly = window.matchMedia && window.matchMedia('(hover: none)').matches;

  /* ------------------------------------------------------------ 1. video loops */
  function markPlaying(wrapper, video) {
    var show = function () { wrapper.classList.add('is-playing'); };
    video.addEventListener('playing', show, { once: true });
    if (!video.paused && video.readyState > 2) show();
  }

  function dropVideo(wrapper, video) {
    wrapper.classList.add('is-failed');
    wrapper.classList.remove('is-playing');
    video.remove();
  }

  function tryPlay(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () { /* autoplay refused: poster stays */ });
  }

  function setupAuto(wrapper, video) {
    markPlaying(wrapper, video);
    video.addEventListener('error', function () { dropVideo(wrapper, video); }, { once: true });
    tryPlay(video);
  }

  function setupHover(wrapper, video) {
    var host = wrapper.closest('a, .am-tile, article') || wrapper;
    var loaded = false;
    var start = function () {
      if (!loaded) {
        loaded = true;
        video.src = video.getAttribute('data-src');
        video.addEventListener('error', function () { dropVideo(wrapper, video); }, { once: true });
        markPlaying(wrapper, video);
        video.load();
      }
      tryPlay(video);
    };
    var stop = function () {
      if (loaded && !video.paused) video.pause();
    };

    if (touchOnly) {
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.intersectionRatio >= 0.6 ? start() : stop(); });
      }, { threshold: [0, 0.6] });
      io.observe(host);
      return;
    }
    host.addEventListener('mouseenter', start);
    host.addEventListener('focusin', start);
    host.addEventListener('mouseleave', stop);
    host.addEventListener('focusout', stop);
  }

  function initVideos(root) {
    (root || document).querySelectorAll('.am-video[data-am-video]').forEach(function (wrapper) {
      if (wrapper.dataset.cmReady) return;
      wrapper.dataset.cmReady = '1';
      var video = wrapper.querySelector('video');
      if (!video) return;
      if (reducedMotion || saveData) { video.remove(); return; }
      if (wrapper.getAttribute('data-am-video') === 'hover') setupHover(wrapper, video);
      else setupAuto(wrapper, video);
    });
  }

  /* ------------------------------------------------------------ 2. machine finder */
  function quote(value) {
    return '"' + String(value).replace(/"/g, '') + '"';
  }

  function initFinder() {
    document.querySelectorAll('[data-am-finder]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        var typeSelect = form.querySelector('[data-am-type]');
        var brandSelect = form.querySelector('[data-am-brand]');
        var modelInput = form.querySelector('[data-am-model]');
        var handle = typeSelect ? typeSelect.value : '';
        var typeOption = typeSelect && typeSelect.selectedOptions[0] ? typeSelect.selectedOptions[0] : null;
        var typeName = typeOption ? typeOption.getAttribute('data-type') || '' : '';
        var typeTag = typeOption ? typeOption.getAttribute('data-tag') || '' : '';
        var brand = brandSelect ? brandSelect.value : '';
        var model = modelInput ? modelInput.value.trim() : '';
        var collectionsRoot = form.getAttribute('data-collections-root') || '/collections';
        var searchUrl = form.getAttribute('data-search-url') || '/search';
        var target;

        if (model) {
          var terms = [];
          if (brand) terms.push('vendor:' + quote(brand));
          if (typeName) terms.push('product_type:' + quote(typeName));
          if (typeTag) terms.push('tag:' + quote(typeTag));
          terms.push(model);
          target = searchUrl + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(terms.join(' '));
        } else if (handle) {
          target = collectionsRoot + '/' + encodeURIComponent(handle);
          if (brand) target += '?filter.p.vendor=' + encodeURIComponent(brand);
        } else if (brand) {
          target = collectionsRoot + '/vendors?q=' + encodeURIComponent(brand);
        } else {
          if (modelInput) modelInput.focus();
          event.preventDefault();
          return;
        }
        event.preventDefault();
        window.location.assign(target);
      });
    });
  }

  /* ------------------------------------------------------------ 3. scoped search */
  function initScopedSearch() {
    document.querySelectorAll('[data-am-scoped-search]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var input = form.querySelector('input[name="q"]');
        var type = form.getAttribute('data-type');
        var tag = form.getAttribute('data-tag');
        if (!input) return;
        var value = input.value.trim();
        if (!value) return;
        var scope = '';
        if (type && value.indexOf('product_type:') === -1) scope += 'product_type:' + quote(type) + ' ';
        if (tag && value.indexOf('tag:') === -1) scope += 'tag:' + quote(tag) + ' ';
        input.value = scope + value;
      });
    });
  }

  /* ------------------------------------------------------------ 4. sticky buy bar */
  function initSticky() {
    var bar = document.querySelector('[data-am-sticky]');
    if (!bar) return;
    // The installment form in the price block is also a product form; only the
    // buy-buttons form lives inside Dawn's <product-form> element.
    var form = document.querySelector('product-form form');
    var submit = form ? form.querySelector('.product-form__submit, [type="submit"]') : null;
    if (!form || !submit) return;

    var addBtn = bar.querySelector('[data-am-sticky-add]');
    var priceEl = bar.querySelector('[data-am-sticky-price]');
    bar.hidden = false;

    var setVisible = function (visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(submit);
    } else {
      setVisible(true);
    }

    addBtn.addEventListener('click', function () {
      if (submit.disabled) return;
      submit.click();
    });

    var sync = function () {
      var price = document.querySelector('.product .price__regular .price-item--regular, .product .price__sale .price-item--sale');
      if (price && priceEl) priceEl.textContent = price.textContent.trim();
      addBtn.disabled = submit.disabled;
      var label = submit.querySelector('span');
      if (label) addBtn.textContent = label.textContent.trim();
    };
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () { window.setTimeout(sync, 50); });
    }
  }

  /* ------------------------------------------------------------ 5. collection facets */
  function initFacets() {
    var root = document.querySelector('[data-am-facets]');
    if (!root) return;

    // Keep the sidebar short on phones: groups start collapsed there.
    if (window.matchMedia('(max-width: 989px)').matches) {
      root.querySelectorAll('details.am-facet').forEach(function (group) { group.open = false; });
    }

    root.querySelectorAll('[data-am-facet-search]').forEach(function (input) {
      var group = input.closest('details');
      if (!group) return;
      var rows = group.querySelectorAll('.am-facet__row');
      var empty = group.querySelector('[data-am-facet-empty]');

      input.addEventListener('input', function () {
        var query = input.value.trim().toLowerCase();
        var shown = 0;
        rows.forEach(function (row) {
          var label = row.getAttribute('data-am-facet-label') || '';
          var hit = query === '' || label.indexOf(query) !== -1;
          row.hidden = !hit;
          if (hit) shown += 1;
        });
        if (empty) empty.hidden = shown !== 0;
      });
    });
  }

  /* ------------------------------------------------------------ boot */
  function boot() {
    initVideos(document);
    initFinder();
    initScopedSearch();
    initSticky();
    initFacets();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (event) { initVideos(event.target); });
})();
